import { useNavigate } from "react-router-dom"

export const Header = () => {
    const navigate = useNavigate();
    return (
        <section className="relative h-screen min-h-[600px] overflow-hidden">
            {/* Background Image */}
            <img
                src="/images/header-bg.png"
                alt="Charter Transportation"
                className="absolute inset-0 h-full w-full object-cover"
            />

            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-black/45"></div>

            {/* Content */}
            <div className="relative z-10 flex h-full items-center justify-center px-4">
                <div className="max-w-5xl text-center text-white">
                    <h1 className="mx-auto max-w-6xl font-bold leading-[1.05] tracking-tight text-3xl sm:text-4xl md:text-5xl 3lg:text-6xl">
                        Welcome to Velox Charter
                    </h1>

                    <h2 className="mx-auto mt-4 max-w-4xl font-light leading-tight tracking-wide text-2xl sm:text-3xl md:text-5xl 3lg:text-6xl text-white/90">
                        Reliable Charter Transportation
                        <br />
                        <span className="font-medium text-white">for Every Occasion</span>
                    </h2>

                    <p className="mx-auto mt-6 max-w-3xl
                                  text-base sm:text-lg md:text-xl
                                  leading-relaxed text-white/90">
                        From corporate travel to private group transportation, <br />
                        we deliver safe, efficient, and hassle-free charter<br />
                        services nationwide.
                    </p>

                    <div className="mt-8">
                        <button
                            className="px-5 py-[10px] bg-primary text-sm text-white font-medium rounded-[20px] hover:shadow-md hover:opacity-90"
                            onClick={() => navigate("/get-quote")}
                        >
                            Get Your Quote
                        </button>
                    </div>
                </div>
            </div>
        </section>
    )
}